import { Skeleton } from '@mui/material';
import React from 'react';
import { getDateString } from 'js/lib/DateUtils';
import UIUtils from '../../../../../../lib/UIUtils';
import { ReactComponent as InfoOutlinedIcon } from 'new/components/icons/fi-rr-info.svg';
import s from './FlowRunCountSummary.module.scss';

const HEADER_DATE_FORMAT = 'MMM D, YYYY';

type DateRange = {
  startDate: Date;
  endDate: Date;
};

type Props = {
  isLoading: boolean;
  numRuns: number;
  range: DateRange;
};

const getRunSummaryLabel = (numRuns: number, range: DateRange) => {
  const startDate = getDateString(range.startDate, HEADER_DATE_FORMAT);
  const runsLabel = UIUtils.toPluralFormat('run', numRuns);

  if (range.endDate >= new Date()) {
    return `${runsLabel} since ${startDate}`;
  }

  const endDate = getDateString(range.endDate, HEADER_DATE_FORMAT);
  return `${runsLabel} from ${startDate} to ${endDate}`;
};

export const FlowRunCountSummary = ({ isLoading, numRuns, range }: Props) => (
  <div className={s.container}>
    <p className={s.summaryLabel}>
      {isLoading ? <Skeleton width={260} height={25} /> : getRunSummaryLabel(numRuns, range)}
    </p>

    <div className={s.info}>
      <InfoOutlinedIcon />
      <span>New Flows may take a few minutes to appear.</span>
    </div>
  </div>
);
